// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"8fbccd03","496":"fc7c14b6"}[chunkId] + ".chunk.js";
};